module.exports = __webpack_public_path__ + "media/images/flags/1x1/kir-4e9b55b7397cc9d86a40cd8f6ac9bda7.svg";